// src/pages/customer/components/details/hooks/useCustomerClubs.js
import { useCallback, useState } from "react";

import PackageSubscriptionAPI from "../../../../atendimento/package/api/PackageSubscriptionAPI";

const api = new PackageSubscriptionAPI();

export default function useCustomerPackages(customerId) {
  const [isLoading, setLoading] = useState(false);
  const [packages, setPackages] = useState([]);

  const getPackages = useCallback(async () => {
    if (!customerId) return;

    try {
      setLoading(true);
      const resp = await api.findPackagesByCustomer(customerId);
      setPackages(Array.isArray(resp.data) ? resp.data : []);
    } catch {
      setPackages([]);
    } finally {
      setLoading(false);
    }
  }, [customerId]);

  return { isLoading, packages, getPackages };
}
